import { render, staticRenderFns } from "./Cvs.vue?vue&type=template&id=64332f45&scoped=true&"
import script from "./Cvs.vue?vue&type=script&lang=js&"
export * from "./Cvs.vue?vue&type=script&lang=js&"
import style0 from "./Cvs.vue?vue&type=style&index=0&id=64332f45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64332f45",
  null
  
)

export default component.exports